import * as angular from 'angular';
import * as moment from 'moment';

import { Group } from '../../models';
import { refreshClick, groupSelected } from '../../common';
import { IPercentageEvolution } from './IPercentageEvolution';

export class PercentageEvolutionBase implements IPercentageEvolution {
    data: any[];
    id: string;
    isLoading: boolean;
    item: any;
    options: any;
    series: any[];

    private _guid: string;

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.data = [];
        this.series = [];
        this.options = {
            title: 'Evolution',
            'isLegendVisible': false,
            display: {
                yAxisFormat: '2.0%',
                yMin: 0,
                yMax: 1
            },
            isTitleVisible: false
        };
        this.id = `id${this.item.guid}`;
        const self = this;
        this._$scope.$on(groupSelected, (event, group: Group) => {
            self._guid = group.guid;
            self.readData(self._guid);
        });

        this._$scope.$on(refreshClick, this.refresh());
    }

    private refresh() {
        const self = this;
        return (event?, data?) => {
            if (data) {
                this.options.display.xMin = moment(data.beginDate).toDate();
                this.options.display.xMax = moment(data.endDate).toDate();
            }
            self.readData(self._guid);
        };
    }

    readData(guid?: string) {
        throw new Error('This method is abstract and has to be overwritten');
    }
}